import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de produccion - Alistamiento material empaque
 **/

class CustomAjustesAlistamiento  extends FormJaivana.form {
        
    constructor(props) {
        super(props);
        this.initForm                           = this.initForm.bind(this);
        this.successDatosFicha                  = this.successDatosFicha.bind(this);
        this.succesTbItemsPorAbastecer          = this.succesTbItemsPorAbastecer.bind(this);
        this.gridOptionsTbItemsPorAbastecer     = Object.assign({}, this.gridOptions);
        this.tamanoDatos                        = 0;
        this.setLote                            = this.setLote.bind(this);
        this.loteChange                         = this.loteChange.bind(this);
        this.successGrabarItem                  = this.successGrabarItem.bind(this);
        this.uploadTable                        = this.uploadTable.bind(this);
        this.finAlistamientoAjuste              = this.finAlistamientoAjuste.bind(this);
        this.archivoPDF                         = this.archivoPDF.bind(this);
        this.successArchivoPDF                  = this.successArchivoPDF.bind(this);
        this.detalleMateriaPrima                = "Ajustes";
        this.verFormula                         = this.verFormula.bind(this);
        this.successVerFormula                  = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula              = Object.assign({}, this.gridOptions);
        this.successClose                       = this.successClose.bind(this);
    }

    initForm(){
        console.log('CustomAjustesAlistamiento @version: 1.01.0054 @author: Mario A. Sepúlveda; @updateBy: Sebastian Rios Echverri');
        this.archivoPDF();
        this.getField('btnGrabarAlisAjuste').setClick(this.finAlistamientoAjuste);

        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'porabastecer', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesTbItemsPorAbastecer,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '267-Servicio_traer_datos_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false
            });

        this.generalFormat.nombre_accion = '267-Produccion_items_ajustes_por_abastecer'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:body,
            success:this.succesTbItemsPorAbastecer,
            error:this.error_,
            general: this.generalFormat,
            showMessage :false
            });*/

        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    archivoPDF(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                detalle: this.detalleMateriaPrima 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'urlalistamiento', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successArchivoPDF,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '267-produccion_fichas-urlalistamiento'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.successArchivoPDF,
                error: this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
    }

    successArchivoPDF(data){
        //console.log("successArchivoPdf",data.data);
        if(data.estado_p === 200){
            
            let tamMatPrima = data.data.length;
            //console.log("longitud datos",tamMatPrima);

            let urlArrary = [];
            let url = [];
            for(let i = 0; i < tamMatPrima; i++){
                let codigo_bodega = data.data[i].codigo_bodega;
                url.push(data.data[i].url_alistamiento);
                let text = 'PDF Materia prima, bodega ';
                //console.log("etiqueta:--",codigo_bodega);

                urlArrary.push("<li><a href='" + url[i] + "' target='_blank'>" + text + codigo_bodega + "</a></li>");
            }
            let etiqueta = "<ul>" + urlArrary + "</ul>";

            this.getField('archivo').setValue(etiqueta);
            //let url = data.data[0].url_alistamiento;
            //let text = 'PDF Materia prima'
            //let etiquetaHTML = "<a href='" + url + "' target='_blank'>" + text + "</a>";
            //this.getField('archivo').setValue(etiquetaHTML);
            //console.log('url alistamiento ==>', data,this.getField('archivo').getValue());
        }
    }

    successDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaAlistamientoAjuste').setVisible(true);
            this.getField('listaAlistamientoAjuste').setItemsFichas(data.model);
        }else{
            this.getField('listaAlistamientoAjuste').setVisible(false);
        }
    }

    succesTbItemsPorAbastecer(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0) 
        {
            this.gridOptionsTbItemsPorAbastecer['rowData']=[];
            this.getField('tablaAlisAjuste').initData(this.gridOptionsTbItemsPorAbastecer);
            this.getField('tablaAlisAjuste').toggle(true);
            this.gridOptionsTbItemsPorAbastecer['rowData'] = data.model;
            this.gridOptionsTbItemsPorAbastecer.paginationPageSize = 100;
           
            let configCellcol = new Map();
            this.tamanoDatos = data.model.length; 
            configCellcol.set('lote',{cellRenderer:this.setLote,singleClickEdit: true,cellStyle: {backgroundColor: "rgb(238,238,238)",borderRadius:"5px" },onCellValueChanged:this.loteChange,width: 150,editable: true,field: 'lote'});
           
            this.getField('tablaAlisAjuste').initData(this.gridOptionsTbItemsPorAbastecer, configCellcol);
        }else{ 
          this.getField('tablaAlisAjuste').toggle(false);
          this.tamanoDatos = 0;
          this.getField('fieldAlert').toggle(true,"No hay items por abastecer","warning");
        }
    }

    setLote(){
        let valor_actual = "ABASTECER";
        let label = document.createElement("div");
        label.textContent = "".formatoPrecio(valor_actual);
        label.setAttribute('class','labelRed');
        return this.createElementJaivana(label);
    }

    loteChange(props){
        if(props.newValue !== ""){
            let datos = {
                datos:{
                    produccion_fichas_id: this.props.data.id_ficha,
                    id: props.data.id,
                    articulo_id: props.data.articulo_id,
                    actividad_id:this.props.data.actividad_id,
                    cantidad: props.data.cantidad_galones,
                    lote:props.newValue, // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarItem,
                error: this.error_,
                general: this.generalFormatPmv
            });

            /*this.generalFormat.nombre_accion = '267-Permite_crear_un_ajuste_leido'; //ojo!este no recibe parametros nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send( 
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successGrabarItem,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successGrabarItem(response){
        if(response.estado_p === 200){
            if(this.tamanoDatos > 1){
                this.uploadTable();
            }else{
                this.uploadTable();    
                this.getField('tablaAlisAjuste').toggle(false);  
            }    
        }
    }

    uploadTable(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        this.getField('btnGrabarAlisAjuste').setDisabled(false);
        this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'porabastecer', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesTbItemsPorAbastecer,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '267-Produccion_items_ajustes_por_abastecer'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:body,
            success:this.succesTbItemsPorAbastecer,
            error:this.error_,
            general: this.generalFormat,
            showMessage :false
            });*/
    }

    finAlistamientoAjuste(){
        if (this.tamanoDatos === 0){
            this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
            this.getField('proceso_id').setValue(this.props.data.proceso_id);
            this.getField('actividad_id').setValue(this.props.data.actividad_id);
            this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
            this.getField('btnGrabarAlisAjuste').setDisabled(true);
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                    proceso_id:this.getField('proceso_id').getValue(),
                    actividad_id:this.getField('actividad_id').getValue(),
                    actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'grabar', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successClose,
                error: this.error_,
                showMessage :false,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = "267-Permite_pasar_a_la_actividad_Pesaje"; 
            this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success:this.successCloseEstage,
                error:this.error_,
                general: this.generalFormat
            });*/
        }else {
            this.getField('fieldAlert').toggle(true,"Aún tiene items por configurar el lote","error");
        }
    }

    successClose(data){
        this.getField('btnGrabarAlisAjuste').setDisabled(false);
        this.successCloseEstage(data);
    }
}

export default CustomAjustesAlistamiento;
FormJaivana.addController("prod-alistamientoajustes",CustomAjustesAlistamiento);